<template>
  <div class="login">
    <div class="background" :style="{background:'url('+url+')',backgroundSize:'100% 100%'}">
      <div  class="title">场地运维管理平台</div>
      <div class="login-card">
        <a-row>
          <a-col class="cardAcol" :span="6">
            <!-- <img class="logo" src="@/assets/img/leswim_logo.png"> -->
            <h1>用户登录</h1>
            <login-form></login-form>
          </a-col>
        </a-row>
      </div>
      <!-- <footer class="copyright">Copyright © All Rights Reserved.</footer> -->
    </div>
  </div>
</template>


<script>
import loginForm from "./components/loginForm";
export default {
  name: "Login",
  components: {
    loginForm: loginForm
  },
  data() {
    return {
      url: require("@/assets/img/login.jpeg")
    };
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  height: 100vh;
  background: #f0f2f5;
  text-align: center;
}
.logo {
  width: 60px;
  margin-top: 20px
}
.background {
  height: 100vh;
}
.title{
  height: 25vh;
  color: white;
  text-align: left;
  font-size: 36px;
  padding-left: 20px;
  padding-top: 30px
}
/*login card*/
.login-card {
  position: relative;
  height: 46%;
  min-height: 340px;
}
.login-card > .ant-row {
  height: 100%;
}
.cardAcol {
  height: 100%;
  background-color: white;
  border-radius: 10px;
  margin-left: 60.6%;
}
.cardAcol h1 {
  font-size: 20px;
  color: black;
  font-weight: bold;
  text-shadow: 1px 1px 1px rgb(114, 110, 110);
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -20%);
  width: 300px;
  text-align: center;
}
.cardAcol form {
  position: absolute;
  top: 40%;
  left: 15%;
  width: 70%;
}
/*版权*/
.copyright {
  color: #ccc;
  position: absolute;
  bottom: 20px;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/login.vue